<template>
  <div class="formBox">
    <div class="row1">
      <div
        class="activeBtn"
        :class="{ gray: active !== 'codeLogin' }"
        @click="setActive('codeLogin')"
      >
        验证码登录
      </div>
      <div
        class="activeBtn"
        :class="{ gray: active !== 'passLogin' }"
        @click="setActive('passLogin')"
      >
        密码登录
      </div>
    </div>
    <div class="row2">
      <loginInput
        placeholder="手机号"
        ref="phoneIpt"
        v-model="from.phone"
        maxlength="11"
      />
    </div>
    <div class="row3">
      <loginInput
        placeholder="验证码"
        ref="codeIpt"
        v-model="from.verifyCode"
        code
        maxlength="4"
        @getCode="getCode"
      />
    </div>
    <div class="row4">
      <agreement />
    </div>
    <el-button
      type="primary"
      class="btn"
      @click="onSubmit"
      :disabled="disabled"
      :loading="loading"
      >登录</el-button
    >
    <div class="btn2 gray" @click="setActive('register')">
      <span class="hoverBlue">没有账号？点击注册</span>
    </div>
  </div>
</template>

<script>
import mixins from "../mixins.js";
export default {
  name: "codeLogin",
  mixins: [mixins],
  data() {
    return {
      from: {
        phone: "",
        verifyCode: "",
      },
      loading: false,
    };
  },
  mounted() {},
  computed: {
    disabled() {
      if (!this.from.phone) return true;
      if (!this.from.verifyCode) return true;
      return false;
    },
  },
  methods: {
    codeApi(pram) {
      return this.$api.postLoginSmsCode(pram);
    },
    async onSubmit() {
      try {
        await this.phoneRules();
        await this.codeRules();
        await this.agreementRules();
        this.loading = true;
        const { info, status, data } = await this.$api.postUserLogin(this.from, false);
        if (status === 200) {
          this.$message({
            message: info,
            type: "success",
          });
          this.setUserInfo(data);
        } else {
          this.$message({
            message: info,
            type: "error",
          });
        }
      } finally {
        await this.awaitFn(500)
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "./formStyle.scss";
</style>
